import React from 'react';
import logoMenu from '@/assets/logo-menu.png';
import { useLocation, useNavigate } from 'react-router-dom';

export default function MenuMobile({ aberto, fechar, links }) {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token'); // ou cookies, se estiver usando cookies
    fechar(); // fecha o menu
    navigate('/login');
  };

  const mostrarBotaoSair = ['/agendamentos', '/cliente', '/painel'].includes(location.pathname);

  return (
    <>
      {aberto && (
        <div
          className="fixed inset-0 bg-black/50 z-[9998]"
          onClick={fechar}
          aria-hidden="true"
        />
      )}

      <div
        className={`fixed top-0 left-0 h-full w-64 bg-black text-white z-[9999] transition-transform duration-300 ease-in-out ${
          aberto ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        {/* Botão de fechar */}
        <div className="flex justify-end p-4">
          <button
            className="text-white text-xl hover:text-[#c9aa7b] transition duration-200"
            onClick={fechar}
            aria-label="Fechar menu"
          >
            ✕
          </button>
        </div>

        {/* Links */}
        <ul className="flex flex-col gap-0 px-6 pt-2">
          {links.map(({ label, href }, index) => (
            <li key={label} className="relative">
              <a
                href={href}
                className="block text-lg font-medium py-3 hover:text-[#c9aa7b] transition"
                onClick={fechar}
              >
                {label}
              </a>
              {index < links.length - 1 && (
                <div className="h-px w-[150px] ml-0 my-1 bg-gradient-to-r from-transparent via-white/30 to-transparent" />
              )}
            </li>
          ))}
        </ul>

        {/* Botão Sair (somente nas rotas específicas) */}
        {mostrarBotaoSair && (
          <div className="px-6 mt-6">
            <button
              onClick={handleLogout}
              className="w-full bg-[#C9AA7B] hover:bg-[#b8936a] text-white font-bold py-2 rounded-full shadow-lg transition-all duration-300"
            >
              Sair
            </button>
          </div>
        )}

        {/* Logo no rodapé */}
        <div className="mt-auto p-4 flex justify-center">
          <img
            src={logoMenu}
            alt="Logo Menu"
            className="h-24 object-contain"
          />
        </div>

        <div className="w-24 h-0.5 mx-auto bg-[#caa874] rounded-full mb-4" />
      </div>
    </>
  );
}
